import { gql } from '@apollo/client';

export const FILTERED_FUNDERS_FOR_SELECT_INPUT = gql`
  query FilteredFundersForSelectInput($input: AllFundersInput!) {
    funders: filteredFunders(input: $input) {
      aggregate {
        count
      }
      pageInfo {
        hasNextPage
        hasPreviousPage
        startCursor
        endCursor
      }
      edges {
        node {
          id
          name
        }
      }
    }
  }
`;
